import * as React from "react";
import {connect} from "react-redux";
import {IBackgroundContainer} from "src/ScrollyInterface";
import {IStateApp} from "src/store/StoreInterface";
import Background from "../components/BackgroundComponent";

class BackgroundContainer extends React.Component<IBackgroundContainer, {}> {
	constructor(props: IBackgroundContainer) {
		super(props);
	}

	public render() {
		return (
			<Background {...this.props} />
		);
	}
}

const mapStateToProps = (state: IStateApp) => {
	return {
		breakpoint: state.ui.breakpoint,
	};
};

export default connect(
	mapStateToProps,
	null
)(BackgroundContainer);



// WEBPACK FOOTER //
// ./src/containers/BackgroundContainer.tsx